import { useEffect, useState } from "react";

export const STATION_LOGO = "/images/logo-round.png";
const EMPTY = { online: false, title: "", artist: "", artwork: "" };

// Radio.co titles usually read "Artist - Song". Split on the first " - "; titles without one are just the song.
const splitTitle = (raw = "") => {
  const i = raw.indexOf(" - ");
  return i > 0 ? { artist: raw.slice(0, i).trim(), title: raw.slice(i + 3).trim() } : { artist: "", title: raw.trim() };
};

// Live "now playing" from the public Radio.co status feed, keyed by the station id in the stream link.
export const useRadioStatus = (streamUrl) => {
  const [status, setStatus] = useState(EMPTY);
  const station = (streamUrl || "").match(/radio\.co\/(s[a-z0-9]+)/i)?.[1];
  useEffect(() => {
    if (!station) {
      setStatus(EMPTY);
      return undefined;
    }
    let alive = true;
    const load = async () => {
      try {
        const res = await fetch(`https://public.radio.co/stations/${station}/status`, { cache: "no-store" });
        const d = await res.json();
        const cur = d?.current_track ?? {};
        if (alive) {
          setStatus({ online: d?.status === "online", ...splitTitle(cur.title ?? ""), artwork: cur.artwork_url_large || cur.artwork_url || "" });
        }
      } catch {
        if (alive) setStatus((s) => ({ ...s, online: false }));
      }
    };
    load();
    const id = setInterval(load, 15000);
    const onVisible = () => { if (document.visibilityState === "visible") load(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      alive = false;
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [station]);
  return status;
};
